import moment from "moment";

export const calculateLeavePeriod = (
  startDate: string,
  endDate: string
): number => {
  // Parse the dates
  const start = new Date(startDate);
  const end = new Date(endDate);

  // Calculate the difference in milliseconds
  const differenceInMillis = end.getTime() - start.getTime();

  // Convert milliseconds to days, including the end date
  const differenceInDays =
    Math.round(differenceInMillis / (1000 * 60 * 60 * 24)) + 1;

  return differenceInDays;
};

export const calculatePeriodTime = (checkIn: string, checkOut: string) => {
  const startTime = moment(checkIn, "HH:mm:ss");
  const endTime = moment(checkOut, "HH:mm:ss");

  const duration = moment.duration(endTime.diff(startTime));
  const hours = Math.floor(duration.asHours());
  const minutes = duration.minutes();

  return `${hours} ชั่วโมง ${minutes} นาที`;
};
